import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingTextComponent } from '@freelancer/components/loading-text';
import { DirectivesModule } from '@freelancer/directives';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { LandingPageShowcaseCardComponent } from './landing-page-showcase-card.component';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    TrackingModule,
    UiModule,
    LoadingTextComponent,
  ],
  declarations: [LandingPageShowcaseCardComponent],
  exports: [LandingPageShowcaseCardComponent],
})
export class LandingPageShowcaseCardModule {}
